import { render, staticRenderFns } from "./Teste.vue?vue&type=template&id=8af3035e&scoped=true&"
import script from "./Teste.vue?vue&type=script&lang=js&"
export * from "./Teste.vue?vue&type=script&lang=js&"
import style0 from "./Teste.vue?vue&type=style&index=0&id=8af3035e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af3035e",
  null
  
)

component.options.__file = "Teste.vue"
export default component.exports